import MapImageLayer from "@arcgis/core/layers/MapImageLayer"
import { MAP_IMAGE_LAYER_URL } from "../constants"



let layer: __esri.MapImageLayer | null = null


export const initLegendLayer = (map: __esri.Map, view: __esri.MapView): void => {
  layer = new MapImageLayer({
    url: MAP_IMAGE_LAYER_URL,
  })
  map.add(layer)
}

export const getLegendLayer = (): __esri.MapImageLayer | null => layer